module.exports = __webpack_public_path__ + "static/img/list_lw_h.cb9712d7.png";